import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';
import { AdsServices } from '../services';
import { ProviderFilePage } from '../provider-file/provider-file';

/**
 * Generated class for the DishViewAllergensPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-provider-new',
    templateUrl: 'provider-new.html',
})
export class ProviderNewPage {

    provider_ads: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public adsServices: AdsServices) {

            this.getElements();
    }

    async getElements() {
        this.adsServices.actual_page = 'Provider new';
        //Recuperamos los proveedores
        this.provider_ads = await this.adsServices.getProvidersAds('3',this.adsServices.actual_page);
    }

    addProvider(provider) {
        //Añadimos el proveidor
        this.adsServices.addProvider(provider);
    }

    openProviderFile(provider) {
        
        this.navCtrl.push(ProviderFilePage, {
            provider: provider
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/ads/provider-new/provider-new.ts